export default __webpack_public_path__ + "static/media/003-yoga.332fb41d.svg";